import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'

class  Cover extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {
      cover: null,
      logo: null,
      overlay: null
    }

    this.options ={
      pad: 230
    }

  }


  mount() {
    //console.log("Mount Cover!");

    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.renderQue = this.render.bind(this)
    stage.on("stage:scroll", this.renderQue);
    this.resize(stage);
  }

  unmount() {
    stage.removeAllListeners();
  }


  resize(e){

    this.h = e.h/2
    this.ref.cover.dataset.h = $(this.ref.cover).height() + this.options.pad
    this.render(e)

    //console.log('resize');

  }

  renderQueCall(){

  }

  render(e){
    if(stage.scrolltop - this.ref.cover.dataset.h < this.ref.cover.dataset.h) {
      // TweenMax.set(this.ref.logo, {alpha: 1, y: e.scrolltop/3, force3D: true})
      TweenMax.set(this.ref.cover, {alpha: 1, y: -e.scrolltop*.4, force3D: true})
    //  TweenMax.set(this.ref.overlay, {alpha: e.scrolltop/this.ref.cover.dataset.h , force3D: true})
    }
    else {
      // TweenMax.set(this.ref.logo, {alpha: 0})
      TweenMax.set(this.ref.cover, {alpha: 0})
    }

      // $('body').toggleClass('no-lang', stage.scrolltop + 80 - this.ref.cover.dataset.h > 0)

  }


}

module.exports = Cover
